import React, { Component } from 'react';

class FAQPopup extends Component {
  render() {
    const { isOpen, onClose } = this.props;

    const popupStyle = {
      position: 'fixed',
      top: 0,
      right: isOpen ? 0 : '-400px', // Adjust the width as needed
      width: '400px', // Adjust the width as needed
      height: '100%',
      backgroundColor: 'white',
      boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
      transition: 'right 0.3s ease-in-out',
      zIndex: 1000,
    };

    const contentStyle = {
      padding: '20px',
      maxHeight: '100%',
      overflowY: 'auto',
    };

    return (
      <div style={popupStyle} className="faq-popup">
        <div style={contentStyle} className="faq-content">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-scroll">
            {/* Add your FAQ content here */}
            <p>Q: Why can't we submit inspection report for a PART/REV/PO in VPI. <br/> </p>
            <p>
            A: Please go through following FAQ's before submissions in VPI<b> <br/><br/> Step A: Validate below criteria before VPI data submission:</b>

            <li>PO Part Number and Revision must match VPI PO Part Number and Revision</li>
            <li>NO Open PO</li>
            <li>Open PO</li>
            Quantity to ship is more than Open PO item<br/>
            <b>Please contact/email the Buyer and VPI Admin team </b> if you encounter any issues mentioned above.<br/>
            <br/><b>Step B: Data Submission</b>
            
            <li>No Inspection Plan</li>
            <li>Cannot submit due to Inspection Plan Error (drawing vs IP mismatch)</li>
            <b>Contact/Email IQC team/ VPI Admin team</b> </p>

            <b>Step C: PO Rev issues</b>
            <li>Please note that each shipment needs to match the PO or notify the buyer when you first receive the PO if you can't make the parts to the revision on the PO.</li>
            <br/>
            {/* Add more FAQ items as needed */}
          </div>
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    );
  }
}

export default FAQPopup;
